import { IMockProps } from '_core/types';

import { ENDPOINT_API_PATH } from '../Definitions/TokenEmailDef';

const autoGenerateSuccess = () => {
  const generateSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'POST',
      path: ENDPOINT_API_PATH,
    },
    configResponse: {
      status: 200,
      data: {},
      headers: {},
    },
  };
  return generateSuccess;
};

const autoGenerateSuccessToken = autoGenerateSuccess();
const generatedSuccessMocks = [autoGenerateSuccessToken];

const ValidateDocumentMocks = [...generatedSuccessMocks];
export default ValidateDocumentMocks;
